/* 
 * src/security/utilities
 *
 * deliberate 'get' methods on this class otherwise components don't re-render when the
 * user is updated.
 */

const ns = "http://fwptools.com/app_metadata";

class UserDelegate {

    constructor(user, isAuthenticated) {
        this.user = user;
        this.isAuthenticated = isAuthenticated;
    }

    getAvatar = () => {
        return this.user.picture;
    }

    getEmailAddress = () => {
        return this.user.email;
    }

    getEmployeeId = () => {
        return this.user[ns].employeeId;
    }

    getFirstName = () => {
        return this.user.given_name;
    }

    getFullName = () => {
        return `${this.getFirstName()} ${this.getLastName()}`;
    }

    getLastName = () => {
        return this.user.family_name;
    }

    getRoles = () => {
        return this.user.roles ?? [];
    }

    isAuthenticated = () => {
        return this.isAuthenticated();
    }

    hasPermission = (permission) => {
        if (!permission) {
            return true;
        }

        const permissions = Array.isArray(permission) ? permission : [permission];

        const has = this.getRoles()
            .find(role => this._isAdmin(role) || this._hasOneOf(role, permissions));

        // console.log('permission: ' + permission + ' - ' + !!has);

        return !!has;
    };

    _hasOneOf = (role, permissions) => {
        return permissions.find(required => required.startsWith(role));
    }

    _isAdmin = (role) => {
        return role === 'admin' || role === 'super';
    }

    static emptyUser() {
        return new UserDelegate({}, () => false);
    }

    static mockUser() {
        return new UserDelegate(
            {
                email: 'jdoe@domain.com',
                employeeId: 2,
                given_name: 'John',
                family_name: 'Doe',
                picture: 'https://ui-avatars.com/api/?name=John+Doe&background=0D8ABC&color=fff',
                roles: ['super']
                //roles:[]
            }, () => true);
    }
}

export default UserDelegate;
